import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ManualAddReference2 from './manualAddReference2';
import {
  ModalDiv,
  Overlay,
} from '../UI/referenceStyles/searchReferenceWrapper';

class ManualAddModal extends Component {
  handleClose = () => {
    const { closeModal } = this.props;
    closeModal();
  };

  handleUpdateReference = (output) => {
    const {
      editor: { insertText },
    } = this.props;
    setTimeout(() => insertText(output), 0);
  };

  render() {
    const { isModalOpen } = this.props;
    if (!isModalOpen) {
      return <div />;
    }

    return (
      <>
        <ModalDiv isModalOpen={isModalOpen} onClick={this.handleClose} />
        <Overlay padding="6px 16px 16px 12px">
          <ManualAddReference2
            closeModal={this.handleClose}
            handleUpdateReference={this.handleUpdateReference}
          />
        </Overlay>
      </>
    );
  }
}

ManualAddModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  editor: PropTypes.shape({
    resolveController: PropTypes.func,
  }).isRequired,
};

export default ManualAddModal;
